module.exports = __webpack_public_path__ + "static/media/pocket-eggy-privacy-policy.82f948ce.md";